import ApiResourceManager from '../ApiResourceManager';

export default class ServiceProviderBrandManager extends ApiResourceManager {
  /**
   * All endpoints act on the on-behalf-of service provider. Passing an
   * explicit id overrides the header derived from the sidebar selection, so
   * the Partners page can edit any partner without re-scoping the dashboard.
   */
  get = (serviceProviderId = undefined) =>
    this.request({
      method: 'GET',
      url: '/service-provider-brand',
      ...(serviceProviderId && { headers: { 'x-on-behalf-of-service-provider': serviceProviderId } }),
    });

  update = (data, serviceProviderId = undefined) =>
    this.request({
      method: 'PUT',
      url: '/service-provider-brand',
      data,
      ...(serviceProviderId && { headers: { 'x-on-behalf-of-service-provider': serviceProviderId } }),
    });

  uploadLogo = ({ type, file }, serviceProviderId = undefined) => {
    const data = new FormData();
    data.append('type', type);
    data.append('file', file);

    return this.request({
      method: 'POST',
      url: '/service-provider-brand/logo',
      data,
      headers: {
        'Content-Type': 'multipart/form-data',
        ...(serviceProviderId && { 'x-on-behalf-of-service-provider': serviceProviderId }),
      },
    });
  };

  deleteLogo = (type, serviceProviderId = undefined) =>
    this.request({
      method: 'DELETE',
      url: '/service-provider-brand/logo',
      data: { type },
      ...(serviceProviderId && { headers: { 'x-on-behalf-of-service-provider': serviceProviderId } }),
    });
}
